var _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _circle, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChatLogoDecoration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 192,
    height: 462,
    viewBox: "0 0 192 462",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 462L20.0002 183.584L172 252.114V0",
    stroke: "url(#paint0_linear_433_72)",
    strokeWidth: 40
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 47.0605,
    y: 228.598,
    width: 11.8408,
    height: 157.16,
    fill: "#33CC66"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 52.4424,
    y: 221.062,
    width: 1.07644,
    height: 7.53508,
    fill: "#33CC66"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 52.4424,
    y: 385.758,
    width: 1.07644,
    height: 12.9173,
    fill: "#33CC66"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 64.2842,
    y: 219.985,
    width: 11.8408,
    height: 9.68796,
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 69.666,
    y: 198.457,
    width: 1.07644,
    height: 21.5288,
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 69.666,
    y: 229.674,
    width: 1.07644,
    height: 55.9749,
    fill: "white"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 81.5078,
    y: 219.985,
    width: 11.8408,
    height: 16.1466,
    fill: "#E63E3E"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 1.07644,
    height: 55.9749,
    transform: "matrix(1 0 0 -1 86.8896 219.985)",
    fill: "#E63E3E"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 86.8896,
    y: 236.132,
    width: 1.07644,
    height: 7.53508,
    fill: "#E63E3E"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 98.7314,
    y: 235.056,
    width: 11.8408,
    height: 13.9937,
    fill: "#E63E3E"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    width: 1.07644,
    height: 13.9937,
    transform: "matrix(1 0 0 -1 104.113 235.056)",
    fill: "#E63E3E"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 104.113,
    y: 249.05,
    width: 1.07644,
    height: 19.3759,
    fill: "#E63E3E"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 115.954,
    y: 246.896,
    width: 11.8408,
    height: 67.8157,
    fill: "#E63E3E"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 121.336,
    y: 243.667,
    width: 1.07644,
    height: 111.95,
    fill: "#E63E3E"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 133.177,
    y: 193.074,
    width: 11.8408,
    height: 121.638,
    fill: "#33CC66"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 138.559,
    y: 188.769,
    width: 1.07644,
    height: 137.784,
    fill: "#33CC66"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 150.4,
    y: 35.9146,
    width: 11.8408,
    height: 158.237,
    fill: "#33CC66"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 155.782,
    y: 30.5322,
    width: 1.07644,
    height: 189.453,
    fill: "#33CC66"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 29.8379,
    y: 311.482,
    width: 11.8408,
    height: 75.3508,
    fill: "#E63E3E"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 35.2197,
    y: 301.795,
    width: 1.07644,
    height: 9.68796,
    fill: "#E63E3E"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 35.2197,
    y: 386.834,
    width: 1.07644,
    height: 10.7644,
    fill: "#E63E3E"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 96,
    cy: 231,
    r: 60,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M81.2034 236.567L69.3177 232.861C66.7484 232.076 66.7341 230.306 69.8934 229.035L116.204 211.145C118.892 210.051 120.415 211.435 119.544 214.904L111.66 252.112C111.108 254.762 109.514 255.395 107.301 254.172L95.1635 245.189L89.5062 250.651C88.9257 251.213 88.4547 251.693 87.5601 251.812C86.6704 251.936 85.9376 251.669 85.4 250.194L81.2605 236.534L81.2034 236.567Z",
    fill: "url(#paint1_linear_433_72)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_433_72",
    x1: 63.4282,
    y1: 57.8416,
    x2: 63.4282,
    y2: 465.876,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "white",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3D3D3",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_433_72",
    x1: 94,
    y1: 211,
    x2: 61.5,
    y2: 258.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#33CC66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#04C35C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatLogoDecoration);
export default __webpack_public_path__ + "static/media/chatLogoDecoration.82436124d9226b5c619fbb153211a2f6.svg";
export { ForwardRef as ReactComponent };